(() => {
  if (customElements.get('uc-weekend-set')) return;
  class WeekendSet extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.data = JSON.parse(this.querySelector('[data-bundle-data]').textContent);
      this.selects = [...this.querySelectorAll('[data-bundle-select]')];
      this.button = this.querySelector('[data-add-both]');
      this.status = this.querySelector('[data-bundle-status]');
      this.querySelectorAll('[data-swatch-group]').forEach((group, index) => {
        group.addEventListener('click', event => {
          const swatch = event.target.closest('[data-swatch-variant]');
          if (!swatch || swatch.disabled) return;
          event.preventDefault();
          this.selects[index].value = swatch.dataset.swatchVariant;
          this.render();
        }, { signal });
        group.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const choices = [...group.querySelectorAll('[data-swatch-variant]:not(:disabled)')];
          if (!choices.length) return;
          let next = choices.findIndex(s => s.dataset.swatchVariant === this.selects[index].value);
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = choices.length - 1;
          else next = (next + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + choices.length) % choices.length;
          this.selects[index].value = choices[next].dataset.swatchVariant;
          this.render();
          choices[next].focus();
        }, { signal });
      });
      this.button.addEventListener('click', () => this.add(), { signal });
      this.mainForm = document.getElementById(this.dataset.formId);
      this.sync = () => {
        const id = this.mainForm?.querySelector('[name="id"]')?.value;
        if (id && this.selects[0].value !== id && this.data.products[0].variants.some(v => String(v.id) === id)) {
          this.selects[0].value = id;
          this.render();
        }
      };
      document.addEventListener('change', event => {
        if (event.isTrusted && !this.contains(event.target) && event.target.matches('input[type="radio"][id^="option-"], select[name^="options"]')) {
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(this.sync, 300);
        }
      }, { signal });
      this.render();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.syncTimer);
    }
    selected() {
      return this.selects.map((s, i) => this.data.products[i].variants.find(v => String(v.id) === s.value));
    }
    render() {
      const variants = this.selected();
      const available = variants.every(v => v?.available);
      const pair = this.data.pairs[variants.map(v => v?.id).join(':')];
      this.button.disabled = this.busy || !available || !pair;
      variants.forEach((v, i) => {
        if (!v) return;
        const image = this.querySelectorAll('.uc-weekend-set__image')[i];
        image.removeAttribute('srcset');
        image.src = v.image;
        image.alt = v.alt;
        this.querySelectorAll('[data-swatch-group]')[i].querySelectorAll('[data-swatch-variant]').forEach(swatch => {
          const checked = swatch.dataset.swatchVariant === String(v.id);
          swatch.setAttribute('aria-checked', String(checked));
          swatch.tabIndex = checked ? 0 : -1;
        });
      });
      this.querySelector('[data-regular]').textContent = pair?.regular || '';
      this.querySelector('[data-total]').textContent = pair?.total || 'Unavailable';
      this.querySelector('[data-savings]').textContent = pair ? 'Save ' + pair.saving : '';
      if (!available) this.message('This combination is unavailable. Please choose another color.', true);
      else if (!this.busy) this.message('');
    }
    message(text, error = false) {
      this.status.textContent = text;
      this.status.dataset.error = String(error);
    }
    async add() {
      if (this.busy || this.button.disabled) return;
      const variants = this.selected();
      if (!variants.every(v => v?.available)) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = 'Adding both…';
      this.setAttribute('aria-busy', 'true');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: variants.map(v => ({ id: v.id, quantity: 1 })) })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'These items could not be added. Check your cart before trying again.');
        this.message('Added to your cart.');
        this.querySelector('[data-cart-link]').hidden = false;
        try {
          if (typeof window.openCartDrawer === 'function') await window.openCartDrawer();
          else document.dispatchEvent(new CustomEvent('uc:cart:open'));
        } catch {
          this.message('Both items were added. Open View cart to review them; the cart drawer could not refresh.');
        }
      } catch (error) {
        this.message(error.message || 'We could not confirm the cart update. Check your cart before retrying.', true);
        this.querySelector('[data-cart-link]').hidden = false;
        // Shopify may add available quantities even when another requested item fails.
        document.dispatchEvent(new CustomEvent('uc:cart:refresh'));
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.button.textContent = 'Add Both — Save 15%';
        this.button.disabled = !this.selected().every(v => v?.available);
      }
    }
  }
  customElements.define('uc-weekend-set', WeekendSet);
})();
